import { useCallback, useContext } from 'react';
import { match } from 'ts-pattern';
import { GlobalTextVariablesContext } from '../../../contexts/global-text-variables-context';
import { getActiveCategories } from '../../dotcms-category';

/** These string values must stay the same as in dotcms, don't change them! */
export enum ResourceType {
  Basics = 'Basics',
  Video = 'Video',
  Documents = 'Documents',
}

export const getResourceTypeFromDotcms = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  resourceType: any,
) => {
  const resourceTypesFromDotcms = resourceType
    ? // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    getActiveCategories(resourceType)
    : [];

  if (
    !resourceTypesFromDotcms ||
    resourceTypesFromDotcms.length === 0 ||
    typeof resourceTypesFromDotcms[0] !== 'string'
  ) {
    return ResourceType.Basics;
  }

  const maybeMatchingEnumKey: ResourceType | undefined = Object.entries(
    ResourceType,
  ).find(([key]) => key === resourceTypesFromDotcms[0])?.[1];

  return maybeMatchingEnumKey ?? ResourceType.Basics;
};

export const useTranslateResourceType = () => {
  const globalTextVariables = useContext(GlobalTextVariablesContext);
  const translateResourceType = useCallback(
    (resourceType: ResourceType) =>
      match({ resourceType })
        .with(
          { resourceType: ResourceType.Basics },
          () => globalTextVariables.articleResourceTypeBasics,
        )
        .with(
          { resourceType: ResourceType.Video },
          () => globalTextVariables.articleResourceTypeVideo,
        )
        .with(
          { resourceType: ResourceType.Documents },
          () => globalTextVariables.articleResourceTypeDocuments,
        )
        .exhaustive(),
    [
      globalTextVariables.articleResourceTypeBasics,
      globalTextVariables.articleResourceTypeVideo,
      globalTextVariables.articleResourceTypeDocuments,
    ],
  );
  return { translateResourceType };
};
